if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      const stickyMedia = document.querySelector(".sticky-media");
      if(stickyMedia && window.outerWidth > 768){
        this._calculateHeight();
      }


      
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }
    _calculateHeight(){
      const productInfo = document.querySelector(".product-info.product-info--sticky");
      this.ticking = false;
      window.addEventListener('scroll',this._scrollSticky.bind(this), false);
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this._calculateStickyMedia()
        }
      });
      resizeObserver.observe(productInfo);
    }
    _scrollSticky(){
      if(!this.ticking) {
        requestAnimationFrame(this._calculateStickyMedia.bind(this));
        // this.ticking = true;
      }
    }

    _calculateStickyMedia(){
      this.ticking = false;
      const productInfo = document.querySelector(".product-info.product-info--sticky");
      let totalHeight = 0;
      document.querySelectorAll(productInfo.dataset.stickyHeightElems).forEach((elem) => {
        totalHeight += elem.getBoundingClientRect().height;
      });
      let productInfoHeight = productInfo.getBoundingClientRect().height;
      let difference = productInfoHeight - totalHeight
      if(difference > 0){
        const headerHeight = document.documentElement.style.getPropertyValue('--header-height')? parseInt(document.documentElement.style.getPropertyValue('--header-height').replace("px",'')):0
        if(window.scrollY - headerHeight > 0  ){
          if(window.scrollY - headerHeight < difference){
            document.querySelector(".sticky-media").style.setProperty("--product-media-margin",(window.scrollY - headerHeight) + 'px' )
          }else{
            document.querySelector(".sticky-media").style.setProperty("--product-media-margin",difference + 'px' )
          }
        }else{
          document.querySelector(".sticky-media").style.setProperty("--product-media-margin",'0px' )
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

        
      let formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      let fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };
      let url = theme.routes.cartAdd
      if(this.dataset.packageForm){
        url = window.Shopify.routes.root + 'cart/add.js'
        const formItems = this.closest("package-form").cartItems;
        fetchRequestOpts =  {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({"items": formItems,'sections': sections,'sections_url': window.location.pathname})
        }
      }

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(url, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

/** InsCoder  WANG.J 2024-08-12 B **/


document.querySelectorAll(".product-custom__package.card-package").forEach((item) => {
  if (!item.querySelector(".package__header").classList.contains("loaded")) {
    item.querySelector(".package__header").classList.add("loaded");

    // 只监听箭头 SVG，而不是整个 package__header
    const arrowIcon = item.querySelector(".package__header-title svg");
    if (arrowIcon) {
      arrowIcon.addEventListener("click", (event) => {
        item.classList.toggle("open");
      });
    }
  }
  const items = item.querySelectorAll(".package-card__item")
  items.forEach( temp => {
    if(!temp.classList.contains("loaded")){
      temp.classList.add("loaded")
      console.log(123)
      temp.querySelector(".package-card__check").addEventListener("click", () => {
        temp.classList.toggle("active")
        document.dispatchEvent(new CustomEvent('on:add-ons:updated'), {});
      })
      temp.querySelector(".qty-input__input").addEventListener("change", () => {
        document.dispatchEvent(new CustomEvent('on:add-ons:updated'), {});
      });
    }
  })


  const reitems = item.querySelectorAll(".recomendation-item")
  reitems.forEach( temp => {
    if(!temp.classList.contains("loaded")){
      temp.classList.add("loaded")
      temp.addEventListener("click", () => {
        temp.classList.toggle("active")
        document.dispatchEvent(new CustomEvent('on:add-ons:updated'), {});
      })
      temp.querySelector(".qty-input__input").addEventListener("change", () => {
        document.dispatchEvent(new CustomEvent('on:add-ons:updated'), {});
      });
      temp.querySelector("quantity-input").addEventListener("click", e => {
        e.stopPropagation();
      })
    }
  })
})

if (!customElements.get('package-form')) {
  class PackageForm extends HTMLElement {
    static get observedAttributes() {
      return [];
    }
    constructor() {
      super();
     
    }
    connectedCallback() {
      this.productInfo = this.closest(".product-info")
      this.addOns = this.querySelector(".add-ons")
      this.cartItems = [{"id":this.dataset.variantId,"quantity": 1}]
      this._initEvent()
      document.addEventListener('on:add-ons:updated', ()=>{this._updateAddOns()});
    }
    disconnectedCallback() {
      document.removeEventListener('on:add-ons:updated', ()=>{this._updateAddOns()});
    }
    get animationDuration() {
   
    }
    attributeChangedCallback(name, oldValue, newValue) {
      
    }
    _updateAddOns(){
      this.cartItems = [{"id":this.dataset.variantId,"quantity": 1}]
      const activeItems = this.productInfo.querySelectorAll(".item.active");
      let activeHTML = "",price = parseInt(this.dataset.variantPrice);
      if(activeItems.length > 0){
        
        this.addOns.classList.remove("hidden")
        activeItems.forEach(item => {
          let cartItem = {}
          const num = item.querySelector(".qty-input__input").value;
          activeHTML += "<li>"+num + " x "+ item.dataset.productTitle+"</li>"
          price += (num * parseInt(item.dataset.variantPrice))
          cartItem.id = item.dataset.variantId
          cartItem.quantity = parseInt(num)
          this.cartItems = this.cartItems.concat(cartItem)
        })
      }else{
        this.addOns.classList.add("hidden")
      }

      this.addOns.querySelector("ul").innerHTML = activeHTML
      let moneyFormat = theme.settings.moneyWithCurrencyFormat.split(" ")[0];
      this.querySelectorAll(".package-form__header-price").forEach( item => {
        item.innerHTML = moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 }));
      })
      const stickyPrice =  document.querySelector(".sticky-navigation .product-sticky-form__price")
      if(stickyPrice){
        stickyPrice.innerHTML = moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 }));
      }
    }
    _initEvent(){
      this.querySelector("[toggle-btn]").addEventListener("click", () => {
        this.classList.toggle("open")
      })
    }

  }
  customElements.define('package-form', PackageForm);
}
/** InsCoder  WANG.J 2024-08-12 E **/
